export default __webpack_public_path__ + "static/media/kotorilogo2.26842b8c.png";